import {State} from '../../state/types/state.js';
import {castDraft, Draft, produce} from 'immer';
import {Context} from '../../state/types/context.js';

export function contexts(state: State): Context[] {
    return Object.values(state.contexts || {});
}

export function addContext(state: State, context: Context) {
    return produce(state, (s: Draft<State>) => {
        s.contexts = s.contexts || {};
        s.contexts[context.id] = castDraft(context);
    });
}

